import { useCallback, useLayoutEffect, useRef } from "react";
import { createBackgroundRefresh, pauseBackgroundRefresh } from "./backgroundRefresh";

/** Only full-screen waiting surfaces own a global background refresh blocker. */
export function useBackgroundRefreshBlocker(active: boolean) {
  useLayoutEffect(() => active ? pauseBackgroundRefresh() : undefined, [active]);
}

/** Stable trigger for timer/focus/data-change refreshes; queued work belongs to its scope. */
export function useBackgroundRefresh(refresh: () => void, scope?: unknown): () => void {
  const callback = useRef(refresh);
  const task = useRef<ReturnType<typeof createBackgroundRefresh> | null>(null);
  useLayoutEffect(() => { callback.current = refresh; });
  useLayoutEffect(() => {
    const current = createBackgroundRefresh(() => callback.current());
    task.current = current;
    return () => { current.dispose(); task.current = null; };
  }, [scope]);
  return useCallback(() => task.current?.request(), []);
}
